import IcAward from '@/assets/ic_award.svg';
import IcCalendar from '@/assets/ic_calendar.svg';
import IcClock from '@/assets/ic_clock.svg';
import IcQuestion from '@/assets/ic_question.svg';

interface Item {
  icon: string;
  text: string;
}

const ITEMS = [
  {
    icon: IcQuestion,
    text: 'Respondé correctamente 10 preguntas de fútbol.',
  },
  {
    icon: IcClock,
    text: 'Tenés 3’ para contestar y ganar.',
  },
  {
    icon: IcCalendar,
    text: 'Jugá una trivia por semana.',
  },
  {
    icon: IcAward,
    text: 'Ganá una medalla para tu medallero.',
  },
];

export const ListItemsTrivia = () => {
  return (
    <>
      {ITEMS.map((data: Item, index) => {
        return (
          <div key={index} className="flex gap-x-2 items-center">
            <div className="rounded-full bg-gdt-blue-light2 p-2">
              <img alt="Calendar" height={17} src={data.icon} width={17} />
            </div>
            <span className="text-sm font-medium text-gdt-gray-2">
              {data.text}
            </span>
          </div>
        );
      })}
    </>
  );
};
